import type { ReactNode } from 'react';

import { useTimeContext } from '../hooks/useTimeContext';
import { BusinessTimezoneContext } from './BusinessTimezoneContext';

export function BusinessTimezoneProvider({ children }: { readonly children: ReactNode }) {
  const { data } = useTimeContext();
  return (
    <BusinessTimezoneContext.Provider value={data?.businessTimezone ?? null}>
      {children}
    </BusinessTimezoneContext.Provider>
  );
}
